import { render, staticRenderFns } from "./HotelsFilters.vue?vue&type=template&id=0abc166d&scoped=true"
import script from "./HotelsFilters.vue?vue&type=script&lang=js"
export * from "./HotelsFilters.vue?vue&type=script&lang=js"
import style0 from "./HotelsFilters.vue?vue&type=style&index=0&id=0abc166d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abc166d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsCaret: require('/home/forge/ab.farescraper.com/components/IconsCaret.vue').default})
